/**************
 Video Items
 *************/

async function setupVideos() {
    // determine if they have tutorial access
    const access = await hasTutorialAccess();

    // loop over each video item element
    document.querySelectorAll(".tutorialVideoItem").forEach(function (element) {
        // save the video id and corresponding popup
        const videoID = element.dataset.videoId;
        const tutorialVideoPopup = document.querySelector(`.tutorialVideoPopup[data-video-id="${videoID}"]`);

        // show proper video title
        if (access || element.classList.contains("free")) {
            // show item
            element.querySelector(".tutorialVideoItemUnlocked").classList.add("active")

            // add click event to open modal
            element.addEventListener("click", function () {
                tutorialVideoPopup.showModal();
                tutorialVideoPopup.querySelector(".tutorialVideoPopupUnlocked").classList.add("active");
                document.querySelector("body").classList.add("noScroll");
            });
        } else {
            // show item
            element.querySelector(".tutorialVideoItemLocked").classList.add("active")

            // add click event to open modal
            element.addEventListener("click", function () {
                tutorialVideoPopup.showModal();
                tutorialVideoPopup.querySelector(".tutorialVideoPopupLocked").classList.add("active");
                document.querySelector("body").classList.add("noScroll");
            });
        }
    });


    /********************
     Video Popup
     *******************/

    document.querySelectorAll(".tutorialVideoPopup").forEach(element => {
        const dialog = element;

        // add event lisener to close event to pause cide
        dialog.addEventListener('close', function () {
            dialog.querySelector("video").pause();
            document.querySelector("body").classList.remove("noScroll");
        });

        // Close on click outside
        element.addEventListener("click", function (event) {
            if (event.target === this) {
                dialog.close();
            }
        });

        // Close on click close button
        element.querySelector(".tutorialVideoPopupUnlockedClose").addEventListener("click", function () {
            console.log('close');
            dialog.close();
        });

        element.querySelector(".tutorialVideoPopupLockedClose").addEventListener("click", function () {
            console.log('close');
            dialog.close();
        });
    });

}

setupVideos();


/**************
 TUTORIAL Dynamic JS (price update)
 *************/

document.addEventListener("DOMContentLoaded", async function () {
    // add to cart
    document.querySelectorAll('.buyTutorialFooterInfoBuy').forEach(function (element) {
        element.addEventListener('click', async function () {
            // add loading
            this.classList.add('loading');

            // add free ticket
            await addProduct({
                id: this.dataset.id,
                quantity: 1
            });

            // remove loading
            this.classList.remove('loading');

            // go to checkout
            window.location.href = '/checkout';
        })
    });
});



